export default __webpack_public_path__ + "static/media/cwu13.eb32d56f.jpeg";